/**
 * @generated SignedSource<<673c8c414a1e9555f57938bec76ab51b>>
 * @relayHash 98ae6c9704c561dde1c5db57965ec69a
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 98ae6c9704c561dde1c5db57965ec69a

import { ConcreteRequest } from 'relay-runtime';
export type DummyAcceptVideoCallInput = {
  roomSid: string;
};
export type useDummyAcceptVideoCallMutation$variables = {
  input: DummyAcceptVideoCallInput;
};
export type useDummyAcceptVideoCallMutation$data = {
  readonly dummyAcceptVideoCall: {
    readonly boolean: boolean | null;
  };
};
export type useDummyAcceptVideoCallMutation = {
  response: useDummyAcceptVideoCallMutation$data;
  variables: useDummyAcceptVideoCallMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DummyAcceptVideoCallPayload",
    "kind": "LinkedField",
    "name": "dummyAcceptVideoCall",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "boolean",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDummyAcceptVideoCallMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDummyAcceptVideoCallMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "98ae6c9704c561dde1c5db57965ec69a",
    "metadata": {},
    "name": "useDummyAcceptVideoCallMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "508f76b83ca72a83d569085f3499c84e";

export default node;
